import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { CTAButton } from './ui/CTAButton';
export function WhatYouGetSection() {
  return <section className="py-4 bg-[#0A0A0A]" data-id="element-173">
      <div className="max-w-[800px] mx-auto px-4" data-id="element-174">
        {/* Book Image + Headline */}
        <div className="mb-4" data-id="element-175">
          <div className="text-center mt-2" data-id="element-176">
            <img src="https://cdn.magicpatterns.com/uploads/csvqFYroAVab1zGEWFti8V/3f7b2d0b-6cab-4bee-8bbf-e691529338ad.jpg" alt="Sistema Listo Para Fabricar - Libro de herrería profesional" className="w-full max-w-xs mx-auto rounded-xl shadow-orange-500/20 mb-2" data-id="element-177" />
            <p className="text-base text-orange-500 font-bold uppercase tracking-wide mb-1" data-id="element-178">
              ¡Ya no mas proyectos fallidos!
            </p>
            <h3 className="text-xl md:text-2xl font-heading font-bold text-white uppercase" data-id="element-179">
              Descubrí el sistema que usan los herreros profesionales
            </h3>
          </div>
        </div>

        {/* Solutions List */}
        <div className="bg-slate-900/80 p-4 md:p-6 rounded-xl border border-white/10" data-id="element-180">
          <h2 className="text-2xl font-heading font-bold text-center text-white uppercase mb-4" data-id="element-181">
            ¿QUÉ VAS A LOGRAR?
          </h2>

          <div className="space-y-3" data-id="element-182">
            <div className="flex items-start" data-id="element-183">
              <CheckCircle2 className="w-5 h-5 text-orange-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-184" />
              <p className="text-sm text-slate-300" data-id="element-185">
                <span className="font-bold text-white" data-id="element-186">
                  Vas a dejar de improvisar
                </span>{' '}
                y empezar a trabajar con un sistema claro, incluso si hoy sentís
                que tu taller está desordenado o estancado.
              </p>
            </div>

            <div className="flex items-start" data-id="element-187">
              <CheckCircle2 className="w-5 h-5 text-orange-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-188" />
              <p className="text-sm text-slate-300" data-id="element-189">
                <span className="font-bold text-white" data-id="element-190">
                  Ahorrarás tiempo, materiales y dinero
                </span>{' '}
                fabricando con planos exactos y procesos probados, sin ensayo y
                error.
              </p>
            </div>

            <div className="flex items-start" data-id="element-191">
              <CheckCircle2 className="w-5 h-5 text-orange-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-192" />
              <p className="text-sm text-slate-300" data-id="element-193">
                <span className="font-bold text-white" data-id="element-194">
                  Lograrás fabricar proyectos de herrería modernos y rentables
                </span>
                , con terminaciones profesionales que te permitan cobrar mejor.
              </p>
            </div>

            <div className="flex items-start" data-id="element-195">
              <CheckCircle2 className="w-5 h-5 text-orange-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-196" />
              <p className="text-sm text-slate-300" data-id="element-197">
                <span className="font-bold text-white" data-id="element-198">
                  Sabrás qué proyectos fabricar
                </span>
                , cuáles se venden todo el año y cuáles te conviene evitar para
                no perder plata.
              </p>
            </div>

            <div className="flex items-start" data-id="element-199">
              <CheckCircle2 className="w-5 h-5 text-orange-500 mr-2 flex-shrink-0 mt-0.5" data-id="element-200" />
              <p className="text-sm text-slate-300" data-id="element-201">
                <span className="font-bold text-white" data-id="element-202">
                  Ganarás la confianza para aceptar trabajos más grandes
                </span>{' '}
                y vas a saber exactamente cuánto cobrar en cada proyecto, sin
                dudar ni regalar tu trabajo.
              </p>
            </div>
          </div>

          <div className="mt-4 text-center" data-id="element-203">
            <p className="text-sm font-heading font-bold text-orange-400 uppercase bg-orange-500/10 py-2 px-4 rounded-lg inline-block mb-4 border border-orange-500/20" data-id="element-204">
              Acceso completo al Sistema Maestro de Herrería
            </p>
            <div className="rounded-xl overflow-hidden border-2 border-orange-500/30 max-w-xs mx-auto" data-id="element-205">
              <video src="https://cdn.magicpatterns.com/uploads/8oin8n5crmpparWE7A5fYB/Pink and Brown Aesthetic Creative Reflections of the Year YouTube Shorts (1).mp4" autoPlay muted loop playsInline className="w-full h-auto object-cover" data-id="element-206" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}